// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2X5cG","tab":"ProcedureTabs_tab__T67mg"};